/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
import { 
    // 取得群組列表
    apiBizGetOrganizationGroupList,
    // 取得該群組業務列表
    apiBizGetMemberByGroup,
    // 取得房東列表
    apiBizGetLandlordList,
    // 取得房源組態
    apiHouseConfig

} from "@/apis/api.js"; 

const types = {
    set_org_group_list: 'globalList/set_org_group_list',
    set_member_by_group: 'globalList/set_member_by_group',
    set_landlord_list: 'globalList/set_landlord_list',
    set_house_config: 'globalList/set_house_config',
}

// count state 必須是 Object
const state = {
    organizationGroupList: [],
    memberByGroupList: [],
    landlordList: [],
    houseConfig: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_ORG_GROUP_LIST: (state) => {
        return state.organizationGroupList
    },
    GET_ORG_MEMBER_BY_GROUP_LIST: (state) => {
        return state.memberByGroupList
    },
    GET_LANDLORD_LIST: (state) => {
        return state.landlordList
    },
    GET_HOUSE_CONFIG: (state) => {
        return state.houseConfig
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizOrgGroupList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetOrganizationGroupList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_org_group_list, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    getBizMemberByGroupList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetMemberByGroup(data)
            .then(res => {
                console.log('apiBizGetMemberByGroup',res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_member_by_group, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    getBizLandlordList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetLandlordList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_landlord_list, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    getHouseConfig ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiHouseConfig()
            .then(res => {
                console.log('getHouseConfig', res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_house_config, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_org_group_list](state, data){
        state.organizationGroupList = data
    },
    [types.set_member_by_group](state, data){
        state.memberByGroupList = data
    },
    [types.set_landlord_list](state, data){
        state.landlordList = data
    },
    [types.set_house_config](state, data){
        state.houseConfig = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global/globalList.js